/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel, { CampaignType, TYPE_NAMES, TYPE_NAME_ARTICLES } from 'cio/models/campaign';
import { lowercase } from 'cio/helpers/lowercase';

interface VisualWorkflowBuilderV2BaseCopyModalReviewModalArgs {
  warnings: string[];
  sourceEnvironmentId: string;
  targetEnvironmentId: string;
  sourceCampaign: CampaignModel;
  targetCampaign: CampaignModel;
  onConfirm: () => unknown;
  onClose: () => unknown;
}

function campaignTypeString(campaign: CampaignModel) {
  let typeNameArticle = TYPE_NAME_ARTICLES[campaign.type];

  let maybeLowercasedTypeName =
    campaign.type === CampaignType.APITriggered ? TYPE_NAMES[campaign.type] : lowercase([TYPE_NAMES[campaign.type]]);

  return `${typeNameArticle} ${maybeLowercasedTypeName}`;
}

export default class VisualWorkflowBuilderV2BaseCopyModalReviewModal extends Component<VisualWorkflowBuilderV2BaseCopyModalReviewModalArgs> {
  get isDifferentEnvironment() {
    return this.args.sourceEnvironmentId !== this.args.targetEnvironmentId;
  }

  get shouldShowFromToCampaignTypeString() {
    return this.args.sourceCampaign.type !== this.args.targetCampaign.type;
  }

  get fromToCampaignTypeString() {
    return `from ${campaignTypeString(this.args.sourceCampaign)} to ${campaignTypeString(this.args.targetCampaign)}`;
  }

  get copyContextString() {
    let context = "You're copying";

    if (this.isDifferentEnvironment) {
      context = `${context} between workspaces`;
    }

    if (this.shouldShowFromToCampaignTypeString) {
      context = `${context} ${this.fromToCampaignTypeString}`;
    }

    context = `${context}. This means that:`;
    return context;
  }
}
